import type { GoodsBasicResponse } from 'shared/src/api/goodsService/getGoodsBasic/types';
import { isNil } from 'shared/src/utils';

/**
 * GoodsBasic에서 프리오더 상품인지 여부를 판별 할수 있도록 하는 함수.
 * @param goodsBasic
 */
export const isSalesMethodIsPreOrder = (
  goodsBasic: GoodsBasicResponse['goods'] | undefined,
) => {
  if (isNil(goodsBasic)) return false;

  return goodsBasic.sales_method_info?.sales_method === 'PRE_ORDER';
};
